import { render, staticRenderFns } from "./GatewayCommand.vue?vue&type=template&id=474bb9e6&"
import script from "./GatewayCommand.vue?vue&type=script&lang=js&"
export * from "./GatewayCommand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports